"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
const SwitchItem = _ref => {
  let {
    id,
    value,
    children
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, children);
};
SwitchItem.displayName = 'SwitchItem';
SwitchItem.propTypes = {};
SwitchItem.defaultProps = {};
var _default = exports.default = SwitchItem;